<template>
    <section class="qty-section">
        <template v-if="specs.length > 0">
        <div class="qty_wrap">
            <select v-model="selectSpec" @change="changeSpec">
                <option :value="item.id" v-for="item in specs">{{ item.title}}</option>
            </select>
            <div class="qty">
                <span><img src="/image/icon/minus01.svg" alt="" @click.prevent="minus"></span>
                <input type="text" class="qty_num form-control" v-model="qty">
                <span><img src="/image/icon/plus01.svg" alt="" @click.prevent="add"></span>
            </div>
        </div>
        <div class="add_cart_btn" @click.prevent="addCart">
            放入購物車
        </div>
        </template>
        <template v-else>
            <div class="add_cart_btn">
                已售完
            </div>
        </template>
    </section>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      qty: 1,
      specs: [],
      selectSpec: null
    };
  },
  mounted() {
    this.getSpecs();
  },
  methods: {
    add() {
      this.qty++;
    },

    minus() {
      if (this.qty > 1) {
        this.qty--;
      }
    },

    addCart() {
      eventHub.$emit("addCart", { id: this.id, qty: this.qty });
    },

    directAddCart() {
      eventHub.$emit("directAddCart", { id: this.id, qty: this.qty });
    },

    getSpecs() {
        axios.get(`/api/products/${this.id}/specs`).then( r => {
            this.specs = r.data;
            if(r.data.length > 0) {
                this.selectSpec = r.data[0].id;
                this.changeSpec();
            }
        })
    },

    changeSpec() {
        eventHub.$emit('getSpec', this.selectSpec);
    }

  }
};
</script>
